/**
 * The grocery "usual" chips worth offering: the most-added items that are
 * not already open on the list. The chips were the top twelve regardless, so
 * "Toothpaste" sat above a list that had Toothpaste on it and one tap added a
 * second line (UI-audit a3-16). A ticked line is in the basket, not wanted,
 * so its usual comes back.
 *
 * Matched on a normalised name: case, outer space and runs of space inside
 * do not make a different item. Pure and import-free for the Worker's suite.
 */
export const normaliseItem = (s: string) => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('de-DE')

export function usualsToOffer<U extends { body: string }>(
  usuals: readonly U[],
  items: readonly { body: string; done_at: string | null }[],
  max: number,
): U[] {
  const open = new Set(items.filter(i => !i.done_at).map(i => normaliseItem(i.body)))
  return usuals.filter(u => !open.has(normaliseItem(u.body))).slice(0, max)
}
